const semanticTokens = {
  colors: {
    Text_Main: {
      default: "#000000",
      _dark: "#FFFFFF",
    },
    Base_Canvas_Bg: {
      default: "#F5F5F7",
      _dark: "#202022",
    },
  },
};

export default semanticTokens;
